// extracted by mini-css-extract-plugin
export default {"root":"PaperPDF_root__k11K8","wrapper":"PaperPDF_wrapper__cpCzz"};